/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientJoinLogDto } from '../../models/client-join-log-dto';

export interface ClientWorkspaceJoinLogControllerJoinUser$Params {

/**
 * 워크스페이스 ID
 */
  id: string;
}

export function clientWorkspaceJoinLogControllerJoinUser(http: HttpClient, rootUrl: string, params: ClientWorkspaceJoinLogControllerJoinUser$Params, context?: HttpContext): Observable<StrictHttpResponse<ClientJoinLogDto>> {
  const rb = new RequestBuilder(rootUrl, clientWorkspaceJoinLogControllerJoinUser.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ClientJoinLogDto>;
    })
  );
}

clientWorkspaceJoinLogControllerJoinUser.PATH = '/api/clientWorkspaceJoinLog/{id}/join';
